import { customCellRenderer, customValueFormatter } from 'src/utils/Functions/aggridUtils'

export const constants = {
  FILE_SIZE: 20,
  UPLOAD_SKU: 'SKU Master Upload',
  UPLOAD_PO: 'PO Upload',
  UPLOAD_VENDOR: 'Vendor Master Upload',
  PREVIEW_SKU: 'SKU Master Preview',
  PREVIEW_PO: 'PO Preview',
  PREVIEW_VENDOR: 'Vendor Master Preview',
  Download_SKU_Template: 'SKU Master Template',
  Download_PO_Template: 'PO Template',
  Download_Vendor_Template: 'Vendor Master Template',
  Download_SKU_ERROR_FILE: 'SKU Master Error File',
  Download_PO_ERROR_FILE: 'PO Template Error File',
  Download_Vendor_ERROR_FILE: 'Vendor Master Error File',
  SKU_TEMPLATE_FILE_NAME: 'sku_master_template',
  PO_TEMPLATE_FILE_NAME: 'po_template',
  VENDOR_TEMPLATE_FILE_NAME: 'vendor_master_template',
  SKU_ERROR_FILE_NAME: 'sku_master_error_file',
  PO_ERROR_FILE_NAME: 'po_template_error_file',
  VENDOR_ERROR_FILE_NAME: 'vendor_master_error_file',
  DELETE_SHOULD_COST_HEADING: 'Delete Should Cost Model',
  CONFIRM_DELETE_SHOULD_COST: 'Please confirm if you want to delete...!',
  PO_VS_SHOULD_COST_CHART_HEADING: 'Cost Trend',
  UPLOAD_TYPE: {
    SKU: 'sku',
    PO: 'po',
    VENDOR: 'vendor',
  },
}
export const messages = {
  UPLOAD_SUCCESSFUL: 'Data uploaded successfully',
  SKU_UPLOAD_SUCCESSFUL: "SKU's uploaded successfully",
  PO_UPLOAD_SUCCESSFUL: 'PO uploaded successfully',
  VENDOR_UPLOAD_SUCCESSFUL: 'Vendors uploaded successfully',
  SKU_UPLOAD_FAIL: 'SKU upload failed',
  PO_UPLOAD_FAIL: 'PO upload failed',
  VENDOR_UPLOAD_FAIL: "Vendor's upload failed",
  UPLOAD_FAIL: 'Data upload failed',
  VALIDATION_FAIL: 'File validation failed',
  DOWNLOAD_FAIL: 'File download failed',

  FILE_SIZE: `  File is larger than  ${constants.FILE_SIZE}MB. (Please select a file with a size less than  ${constants.FILE_SIZE}MB)`,
  FILE_PASSWORD_PROTECTED: 'File is password protected. (Please select an unprotected file)',
  COLUMN_MISSMATCH:
    'File validations failed due to column mismatch. (Please download template for reference)',
  SKU_INVALID: " SKU's are invalid",
  PO_INVALID: " PO's are invalid",
  VENDOR_INVALID: " Vendor's are invalid",
  PREVIEW_HEADING:
    'File Validation Successful. This is a preview of initial 5 records from the selected files.',
  DOWNLOAD_ERROR_FILE: 'Download Error File',
  EMPTY_ROWS_FILE:
    'File validation failed as empty rows detected. (Please upload file with non-empty records)',
  PO_VS_SHOULD_COST_CHART_ERROR:
    'Unable to generate Cost Trend. Please verify if complete breakdown is added and commodities are attached!',
  SHOULD_COST_CHART_ERROR:
    'Model creation status is "In Progress" , Please save and publish model to generate Should Cost Trend ',
  STANDARD_TAXONOMY_ERROR: 'Failed to get categories taxonomy'
}

export const previewTable = {
  sku: [
    {
      headerName: 'Primary ID',
      field: 'primary_id',
      cellStyle: {
        textTransform: 'capitalize',
        fontWeight: 'bold',
      },
    },
    {
      headerName: 'Secondary ID',
      field: 'secondary_id',
      cellStyle: {
        textTransform: 'capitalize',
        fontWeight: 'bold',
      },
      cellRenderer: customCellRenderer,
      filterParams: {
        valueFormatter: customValueFormatter,
      },
    },
    {
      headerName: 'Desc',
      field: 'description',
      cellStyle: {
        textTransform: 'capitalize',
      },
    },
    {
      headerName: 'Level 1',
      field: 'level_1',
      cellStyle: {
        textTransform: 'capitalize',
      },
    },
    {
      headerName: 'Level 2',
      field: 'level_2',
      cellStyle: {
        textTransform: 'capitalize',
      },
    },
    {
      headerName: 'Level 3',
      field: 'level_3',
      cellStyle: {
        textTransform: 'capitalize',
      },
    },
    {
      headerName: 'Primary Vendor ID',
      field: 'primary_vendor_id',
      cellStyle: {
        textTransform: 'capitalize',
      },
    },
  ],
  po: [
    {
      headerName: 'Fiscal Year',
      field: 'fiscal_year',
      cellStyle: {
        textTransform: 'capitalize',
      },
    },
    {
      headerName: 'Fiscal Month',
      field: 'fiscal_month',
      cellStyle: {
        textTransform: 'capitalize',
      },
    },
    {
      headerName: 'Primary ID',
      field: 'primary_id',
      cellStyle: {
        textTransform: 'capitalize',
      },
    },
    {
      headerName: 'Vendor ID',
      field: 'vendor_id',
      cellStyle: {
        textTransform: 'capitalize',
      },
    },
    {
      headerName: 'Cost',
      field: 'cost',
      cellStyle: {
        textTransform: 'capitalize',
      },
    },
    {
      headerName: 'Sales Quantity',
      field: 'sales_quantity',
      cellStyle: {
        textTransform: 'capitalize',
      },
    },
    {
      headerName: 'PO Volume',
      field: 'po_volume',
      cellStyle: {
        textTransform: 'capitalize',
      },
    },
    {
      headerName: 'Currency',
      field: 'currency',
      cellStyle: {
        textTransform: 'capitalize',
      },
    },
  ],
  vendor: [
    {
      headerName: 'Vendor Id',
      field: 'vendor_id',
      cellStyle: {
        textTransform: 'capitalize',
      },
    },
    {
      headerName: 'Vendor Name',
      field: 'vendor_name',
      cellStyle: {
        textTransform: 'capitalize',
      },
    },
    {
      headerName: 'Country',
      field: 'country',
      cellStyle: {
        textTransform: 'capitalize',
      },
    },
  ],
}

export const color = {
  PO_TRENDLINE: '#118DFF',
  SHOULD_COST_TRENDLINE: '#E66C37',
  PO_SC_TRENDLINE: '#77B0BE'
}
